import { observer } from "mobx-react-lite";
import { Button, Modal } from "@heroui/react";
import { gasStationsStore } from "@/stores/GasStationsStore";

const DeleteConfirmModal: React.FC = observer(() => {
  const { deleteTarget, isDeleting } = gasStationsStore;

  return (
    <Modal.Backdrop
      isOpen={deleteTarget != null}
      onOpenChange={(open) => {
        if (!open) gasStationsStore.cancelDelete();
      }}
    >
      <Modal.Container>
        <Modal.Dialog>
          <Modal.CloseTrigger />
          <Modal.Header>
            <Modal.Heading>Удалить заправку?</Modal.Heading>
          </Modal.Header>
          <Modal.Body>
            <p className="gs-delete-modal__text">
              Заправка будет удалена без возможности восстановления.
              {deleteTarget?.name ? (
                <>
                  <br />
                  <strong>{deleteTarget.name}</strong>
                </>
              ) : null}
            </p>
          </Modal.Body>
          <Modal.Footer className="gs-delete-modal__footer">
            <Button
              variant="ghost"
              onPress={() => gasStationsStore.cancelDelete()}
              isDisabled={isDeleting}
            >
              Отмена
            </Button>
            <Button
              variant="danger"
              onPress={() => void gasStationsStore.confirmDelete()}
              isPending={isDeleting}
            >
              Удалить
            </Button>
          </Modal.Footer>
        </Modal.Dialog>
      </Modal.Container>
    </Modal.Backdrop>
  );
});

DeleteConfirmModal.displayName = "DeleteConfirmModal";
export default DeleteConfirmModal;
